import { CommonGet, CommonPost } from "../../../utils/CommonFetch";


export default {
    getAllRoutesByFilter,
    getAllOperationEntitiesForDropDown,
    filterCollectionPointRoute,
    getAlGroupsForDropdown,
    GetCollectionPointsFilter
};


async function getAllRoutesByFilter(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/ProductCollection/GetAllRootLocationsByFilter', null);
    for (let item of Object.entries(response.data)) {
        
            dataArray[item[1]["productCollectionID"]] = item[1]["cardReadGPS"]
    }
    return dataArray;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function filterCollectionPointRoute(data) {
    var form ={
        collectionPointID: parseInt(data.collectionPointID),
        searchDate: data.searchDate
    }
    var result = await CommonPost('/api/ProductCollection/GetAllRootLocationsByFilter', null,form);
    
    return result;
}

async function getAlGroupsForDropdown() {
    var groupArray = [];

    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function GetCollectionPointsFilter(operationEntityID) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/CollectionPoint/GetCollectionPointByOperationEntityId', 'operationEntityID=' + operationEntityID);

    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }
    return collectionPointArray;
}
